export default {
  // btn
  site_btn_info: '保存信息',
  site_btn_back: '返回',

  // site
  site_title: '站点',
  site_overview: '概览',
  site_device: '设备',
  site_fault: '故障',
  site_event: '事件',
  site_info_title: '站点信息',
  site_info_customer: '隶属客户',
  site_info_status: '状态',
  site_info_build_date: '建站日期',
  site_info_address: '地址',
  site_info_notification: '通知接收人',
  site_device_status: '设备状态分布',
  site_device_total: '全部',
  site_device_offline: '离线',
  site_device_online_offline: '在线 / 离线',
  site_device_alarming: '告警',
  site_events: '事件',

  site_device_category_charging: '充电桩设备',
  site_device_category_charging_ac: '交流充电桩',
  site_device_category_charging_energy: '储能充电桩',
  site_device_category_energy: '储能设备',
  site_device_category_energy_home: '户储设备',
  site_device_category_v2g: 'V2G设备',

  // 列表
  site_table_name: '站点名称',
  site_table_devices_number: '设备数量',
  site_table_divices_offline_number: '离线设备数',
  site_table_warning_state: '告警状态',
  site_table_user: '操作用户',
  site_table_time: '时间',
  site_table_operation: '操作类型',

  // 详情tabs
  site_tab_status_statistics: '状态统计',
  site_tab_traffic_statistics: '流量统计',
  site_tab_cumulative_statistics: '累计统计',
  site_tab_admin_list: '管理员列表',

  // 管理员列表
  site_table_admin_name: '管理员名称',
  site_table_admin_role: '角色',
  site_table_admin_alarm: '是否通知对象',
  site_table_admin_addtime: '添加时间',

  // confirm
  site_confirm_delete_title: '删除该站点?',
  site_confirm_delete_description: '如该站点下还绑定有设备，则不允许删除',
  site_confirm_diabled_title: '禁用该站点?',
  site_confirm_enabled_title: '启用该站点?',
  site_confirm_content: '站点名称: {name}',

  // 表单
  site_form_belong_customer: '隶属客户',
  site_form_belong_customer_placeholder: '请选择隶属客户',
  site_form_name: '站点名称',
  site_form_name_placeholder: '请输入站点名称',
  site_form_image: '图片',
  site_form_code: '站点编号',
  site_form_code_placeholder: '请输入站点编号',
  site_form_contact: '联系人',
  site_form_contact_placeholder: '请输入联系人',
  site_form_phone: '联系电话',
  site_form_phone_placeholder: '请输入联系电话',
  site_form_build_date_placeholder: '请选择建站日期',
  site_form_address_placeholder: '请输入地址',
  site_form_user_placeholder: '请输入关键字：如管理员名称、角色名称',
  site_form_notification_placeholder: '请选择通知接收人',

  // tabs
  site_tabs_edit_event: '站点编辑事件',
  site_tabs_device_edit_event: '设备编辑事件',
  site_tabs_device_control_event: '设备控制事件',
  site_tabs_device_config_event: '设备配置事件',
};
